export enum DropdownExpandDirection {
  Up = 'up',
  Down = 'down',
  Auto = 'auto',
}
